import { Select, Text } from "@fidelix/fx-miranda";
import styled from "styled-components";
import { useHistoryReplayContext } from "./history-replay-context";

const options = [
  { value: 10, name: "10x" },
  { value: 5, name: "5x" },
  { value: 3, name: "3x" },
  { value: 2, name: "2x" },
  { value: 1, name: "1x" },
  { value: 0.5, name: `${(0.5).toLocaleString()}x` },
  { value: 0.25, name: `${(0.25).toLocaleString()}x` },
];

const defaultOption = options[2];
export function HistoryReplayPlaybackSpeedButton() {
  const { playbackSpeed, setPlaybackSpeed } = useHistoryReplayContext();

  const onValueChange = (name: string) => {
    const option = options.find((o) => o.name === name) ?? defaultOption;
    setPlaybackSpeed(option.value);
  };

  const selected =
    options.find((o) => o.value === playbackSpeed) ?? defaultOption;

  return (
    <Container>
      <SpeedSelect
        aria-label="replay-speed-multiplier-select"
        onSelect={onValueChange}
        selected={selected?.name}
        showArrow={false}
      >
        {options.map((o) => (
          <Option key={o.value} value={o.name}>
            <Text variant="bodySmall">{o.name}</Text>
          </Option>
        ))}
      </SpeedSelect>
    </Container>
  );
}

const SpeedSelect = styled(Select)`
  min-width: 100%;
  max-width: 100%;
  & span {
    min-width: 100%;
    text-align: center;
    overflow: visible;
  }
`;
const Option = styled(Select.Option)`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
`;

const Container = styled.div`
  width: 100%;
  height: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
